import { render, staticRenderFns } from "./SendQuotesFormScalesByWeight.vue?vue&type=template&id=24123ffe&scoped=true"
import script from "./SendQuotesFormScalesByWeight.vue?vue&type=script&lang=js"
export * from "./SendQuotesFormScalesByWeight.vue?vue&type=script&lang=js"
import style0 from "./SendQuotesFormScalesByWeight.vue?vue&type=style&index=0&id=24123ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24123ffe",
  null
  
)

export default component.exports